import React from 'react'
import styles from './interlude.module.scss'

const Interlude = () => {
    return (
        <div className={styles.interlude}>
            <div className={styles.container}>
                <h2 className={`${styles.textCenter} ${styles.title}`}>Browse our services</h2>
                <p className={`${styles.title} ${styles.titleBig} ${styles.titleCenter}`}>"Basic m-commerce audit" and "Mobile ecosystem assessment"</p>
            </div>
        </div>
    )
}

export default Interlude
